// extracted by mini-css-extract-plugin
export var callout = "fp-yy";
export var calloutDark = "fp-Ey";
export var callout__content = "fp-Cy";
export var callout__headline = "fp-Dy";
export var callout__img = "fp-Ay";
export var callout__imgPad = "fp-By";
export var callout__link = "fp-zy";
export var mt0 = "fp-ry";
export var mt1 = "fp-sy";
export var mt2 = "fp-ty";
export var mt3 = "fp-uy";
export var mt4 = "fp-vy";
export var mt5 = "fp-wy";
export var mt6 = "fp-xy";